/*!
 * slxControls v1.1.0 (http://selerix.com)
 * Copyright 2017 Selerix Systems, Inc. All Rights Reserved.
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 *
 * Dependencies: jQuery v1.10+, Bootstrap v3.2+, polyfills.js
 */
(function () {
	'use strict';
	var x = window.SlxControl;

	/*
	 * slx.status
	 * Dependencies: slx.core
	 */
	x.slx.status = function status(el, content, theme) {
		var that = this;
		if (el === void 0) { x('body').append(el = $('<DIV/>')); }
		x.slx.base.apply(that, [el, content, theme]);

		el = that._element;
		if (el === void 0) { return this; }
		else if (el.length === 0) { return el; }

		that.id = that.id || el.slxUniqueId();
		that.selector = '#' + that.id;
		that.container = x(that.selector + '_container');
		that.defaultContent = 'Save Successful';
		that.content = that.content || typeof (content) === 'string' ? content : that.defaultContent;
		that.theme = that.theme || theme || 'success';
		that.animationSpeed = 400;
		that.duration = 2000;

		var _icon, _hideTimeout, _hideDelay;
		that.show = function () {
			clearTimeout(_hideTimeout);
			clearTimeout(_hideDelay);
			that.container.removeClass('hide').show(0, function () { x(this).css({ bottom: '0px' }); });
			that.hide();
		};
		that.hide = function () {
			_hideTimeout = setTimeout(function () {
				that.container.css({ bottom: '-' + that.container.height() + 'px' });
				clearTimeout(_hideDelay);
				_hideDelay = setTimeout(function () { that.container.hide(); clearTimeout(_hideDelay); }, that.animationSpeed);
			}, that.duration);
		};
		that.context = function (content, theme) {
			that.content = content || that.defaultContent;
			that.theme = theme || 'success';

			el.removeClass('alert-success').removeClass('alert-danger').removeClass('alert-info').removeClass('alert-warning').addClass('alert-' + that.theme);
			_icon = $('<SPAN/>').addClass('slx-icon').addClass(that.icon());

			el.html(that.content);
			el.prepend(_icon);
			that.show();
		};
		that.icon = function () {
			return (x.slx.config && (x.slx.config.icon[that.theme] || x.slx.config.icon.default)) || '';
		};

		/* initialization */
		(function () {
			if (!el.hasClass('slx-context-status')) { el.addClass('slx-context-status'); }
			if (!el.hasClass('alert')) { el.addClass('alert'); }
			el.removeClass('alert-success').removeClass('alert-danger').removeClass('alert-info').removeClass('alert-warning').addClass('alert-' + that.theme);

			if (that.container.length === 0) {
				el.wrap(x('<DIV/>').attr('id', that.id + '_container').attr('data-target', that.selector).addClass('slx-context-status-container').addClass('hide'));
				that.container = x(that.selector + '_container');
			}

			_icon = $('<SPAN/>').addClass('slx-icon');
			if (!x.slx.config) {
				setTimeout(function () {
					_icon.addClass(that.icon());
				});
			} else {
				_icon.addClass(that.icon());
			}
			el.html(that.content);
			el.prepend(_icon);

			that.show();
		})();

		/* events */
		(function () {
			el.off('show.slx.ac').on('show.slx.ac', function () { });
			el.off('hide.slx.ac').on('hide.slx.ac', function () { });
		})();

		el[0].slxStatus = this;
		el[0].isSlxControl = true;

		return el;
	};
	x.slx.status.prototype = Object.create(x.slx.base.prototype);
	x.slx.status.prototype.constructor = x.slx.status;

	/* jQuery extenders */
	x.fn.extend({
		slxStatus: function () {
			var slx = this.slxControl('slxStatus', arguments) || new x.slx.status(this, arguments);
			if (arguments.length > 0) {
				var arg = arguments[0], args = Array.prototype.slice.call(arguments, 1);
				if (typeof arg === 'string' && slx.hasOwnProperty(arg)) { return typeof (slx[arg]) === 'function' ? slx[arg].apply(slx, args) : slx[arg]; }
				else if (typeof arg !== 'string') { x.extend(slx, arg); }
			}
			return this;
		}
	});
	x.slxStatus = function (content, theme) {
		var el = x('.slx-context-status');
		var slx = el.slxControl('slxStatus');
		if (slx !== null) { slx.context(content, theme); }
		else { slx = new x.slx.status(el.length ? el : void 0, content, theme); }
	};
	x(function () { x('.slx-context-status').each(function () { x(this).slxStatus(); }); });

	return x;
})();